/*
 * @Author: lmm
 * @Date: 2024-08-15 10:44:21
 * @LastEditors: lmm
 * @LastEditTime: 2024-10-28 10:09:34
 * @Description: 
 */
function isWeChatWeb() {
	var ua = navigator.userAgent.toLowerCase();

	var isWeixin = ua.indexOf('micromessenger') != -1;

	return isWeixin;
}

export default isWeChatWeb();
